export enum CategoryEnum {
  DoctorConsultation = 1,
  Pharmacies = 2,
  Labs = 3,
  Scans = 4,
  ClinicServices = 5,
  Surgical = 6,
}

export const PriceListIdForCategory = {
  [CategoryEnum.Labs]: 6,
  [CategoryEnum.Scans]: 6,
  [CategoryEnum.ClinicServices]: 6,
  [CategoryEnum.Surgical]: 6,
};

export const AllowEditServiceTypePriceListId = 6;

//  create enum for service type
export enum ServiceTypeEnum {
  Percentage = 1,
  Fixed = 2,
}
// update  getServicesTypes to use the ServiceTypeEnum
export const getServicesTypes = (currency: string) => ({
  [ServiceTypeEnum.Fixed]: {
    value: ServiceTypeEnum.Fixed,
    label: currency,
  },
  [ServiceTypeEnum.Percentage]: {
    value: ServiceTypeEnum.Percentage,
    label: '%',
  },
});
